
import { computed, defineComponent, nextTick, reactive, ref, toRefs, watch } from 'vue'
import { useStore, mapState, mapMutations, mapActions } from 'vuex'
import { useRoute } from 'vue-router'
import { setTheme } from '@/styles/theme'
import StocksPage from './stocks.vue'
import ExponentPage from './exponent.vue'

export default defineComponent({
  components: {
    StocksPage,
    ExponentPage
  },
  setup(props: any, context: any) {
    const route = useRoute()
    const { markettype = '0', theme = 'dark' } = route.query

    const pageData: any = reactive({
      theme: theme,
      markettype: markettype
    })

    // 变换主题
    function changeTheme() {
      setTheme(pageData.theme)
    }
    changeTheme()

    return {
      ...toRefs(pageData),
      changeTheme
    }
  }
})
